export enum EmploymentTypeEnum {
  FULL_TIME = 'Full-Time',
  PART_TIME = 'Part-Time',
  RETIRED = 'Retired',
  TERMINATED = 'Terminated',
  TERMINATED_NO_COBRA = 'Terminated No Cobra',
  LEAVE = 'Leave',
  NON_PAID_LEAVE_OF_ABSENCE = 'Non-paid LOA',
}
